import { render, staticRenderFns } from "./DetailContainer.vue?vue&type=template&id=1b627958"
import script from "./DetailContainer.vue?vue&type=script&lang=js"
export * from "./DetailContainer.vue?vue&type=script&lang=js"
import style0 from "./DetailContainer.vue?vue&type=style&index=0&id=1b627958&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports